module.exports = __webpack_public_path__ + "media/img/uploads/event-featured-thumb-03-b73ab8d42cb4feee90d048a0d6cdd50a.jpg";